import React, {useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const InvestedBlock = ({
  investedAmount,
  customBlkClass = null,
  redirectionText = 'Portfolio',
  redirectionClick,
}) => {
  return (
    <View style={styles.investedContainer}>
        <FormTextLabel
            labelStyles={{...globalFontStyle.appFontSubText,color: globalConfigurableData.primaryTextColor1, marginRight: 40}}
            label={"Current investment is."} rest={{investedAmount: investedAmount}} >
            <FormTextLabel
                labelStyles={{...globalFontStyle.appFontSubText, color: globalConfigurableData.secondaryTextColor1, marginRight: 40}}
                label={"\nCheck portfolio to sell"} />
        </FormTextLabel>

      <TouchableOpacity onPress={redirectionClick}>
          <FormTextLabel
              labelStyles={[
                  globalFontStyle.appFontSubText,
                  {
                      color: GlobalScreens.Event.InvestedTxt,
                      paddingHorizontal: 10,
                      paddingVertical: 5,
                      borderColor: GlobalScreens.Event.InvestedTxt,
                      borderWidth: 1,
                      backgroundColor: GlobalScreens.Event.InvestedBox,
                      borderRadius: GlobalScreens.Portfolio.btnBorderRadius,
                  },
              ]}
              label={"Portfolio"} />
      </TouchableOpacity>
    </View>
  );
};

export default InvestedBlock;

const styles = StyleSheet.create({
  investedContainer: {
    marginTop: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingVertical: 15,
    alignItems: 'center',
    borderWidth: 0.75,
    borderColor: GlobalScreens.Event.borderColor,
    backgroundColor: GlobalScreens.Event.cardBgColor,
    borderRadius: 8,
  },
  investAmountText1: {},
  investedAmountText2: {},
});
